import { createApp } from 'vue';
import Cloudinarize from '@plugins/cloudinarize';
import KFormField from '@components/forms/form_field.vue';
import KInput from '@components/inputs/input.vue';
import SystemButton from '@components/buttons/system-button.vue';
import Box from '@components/box.vue';
import { initSentry } from '@utils';
import Loader from '@components/loader/loader.vue';
import Illustration from '@components/illustration.vue';
import AuthMixin from '../src/common/mixins/auth';

initSentry();

const app = {
  components: {
    KFormField,
    KInput,
    Box,
    Loader,
    SystemButton,
    Illustration,
  },

  mixins: [AuthMixin],

  mounted() {
    if (/[?&]login=/.test(window.location.search)) {
      $('#loginModal').modal('show');
    }
  },
};

createApp(app)
  .use(Cloudinarize)
  .mount('.login-vue');
